import { useNavigate, useLocation } from 'react-router-dom';
import { Modal } from 'react-bootstrap';
import DegreeForm from '../components/forms/DegreeForm';
import DegreeTable from '../components/DegreeTable';

const DegreeModel = () => {
     const navigate = useNavigate();
     const location = useLocation();
     const showModal = location.pathname === '/degrees/add';

     const handleCloseModal = () => {
          navigate('/degrees');
     };

     return (
          <div>
               <DegreeTable />
               <Modal show={showModal} onHide={handleCloseModal} size="md" centered>
                    <Modal.Header closeButton>
                         <Modal.Title>Add Degree</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                         <DegreeForm />
                    </Modal.Body>
               </Modal>
          </div>
     );
};

export default DegreeModel;